module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "mask",
    staticClass: "content-wrapper mask",
    attrs: {
      "id": 'view-' + _vm.name
    },
    on: {
      "touchstart": _vm.handleClick,
      "mousedown": _vm.handleClick
    }
  }, [_c('background-video-player', {
    key: _vm.videoPlayerId,
    ref: _vm.videoPlayerId,
    attrs: {
      "videos": _vm.videoSource1,
      "videoPlayerId": _vm.videoPlayerId,
      "hoverableId": _vm.hoverableId
    },
    on: {
      "playtime-event": _vm.handlePlayTimeUpdate
    }
  }), _vm._v(" "), _c('hoverable-svg', {
    ref: _vm.hoverableId,
    attrs: {
      "hoverableItems": _vm.hoverable,
      "hoverableId": _vm.hoverableId
    }
  }), _vm._v(" "), _c('div', {
    ref: "maskOverlay",
    staticClass: "mask_overlay",
    attrs: {
      "id": "maskOverlay"
    }
  }, [_c('background-video-player', {
    key: _vm.videoPlayerIdMaskOverlay,
    ref: _vm.videoPlayerIdMaskOverlay,
    staticStyle: {
      "height": "1080px !important",
      "width": "1920px !important"
    },
    attrs: {
      "videos": _vm.videoSource2,
      "videoPlayerId": _vm.videoPlayerIdMaskOverlay,
      "hoverableId": _vm.hoverableOverlayId
    }
  }), _vm._v(" "), _c('hoverable-svg', {
    ref: _vm.hoverableOverlayId,
    attrs: {
      "hoverableItems": _vm.hoverableOverlay,
      "hoverableId": _vm.hoverableOverlayId
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "backdrop",
    staticClass: "backdrop background"
  }), _vm._v(" "), _c('div', {
    ref: "mask_handle",
    staticClass: "mask_handle",
    attrs: {
      "id": "dragme"
    }
  }, [_c('svg', {
    attrs: {
      "id": "splitbar",
      "width": "200px",
      "height": "1080px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('line', {
    staticStyle: {
      "stroke": "rgb(224, 178, 80)",
      "stroke-width": "10"
    },
    attrs: {
      "x1": "100",
      "y1": "0",
      "x2": "100",
      "y2": "1080"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "540",
      "r": "42",
      "stroke": "rgb(225, 179, 81)",
      "stroke-width": "10",
      "fill": "rgb(224, 178, 80)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "stroke": "rgb(224, 178, 80)",
      "stroke-dasharray": "820",
      "stroke-dashoffset": "820",
      "stroke-width": "5",
      "fill": "transparent"
    },
    attrs: {
      "id": "outter",
      "d": "M100,540 m0,-95 \n       a 95,95 0 0,1 0,190 \n       a 95,95 0 0,1 0,-190"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "stroke-dashoffset",
      "dur": "6s",
      "to": "-820",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "white",
      "transform": "translate(65 527.5)"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "10,12.5 25,0 25,25",
      "fill": "white",
      "stroke": "white"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "10,12.5 25,0 25,25",
      "fill": "white",
      "stroke": "white",
      "transform": "rotate(180, 12.5, 12.5) translate(-40 0)"
    }
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('cf-button', {
    key: 'view-' + _vm.name + '-continue',
    staticClass: "btn-continue",
    attrs: {
      "width": 280,
      "id": 'view-' + _vm.name + '-continue',
      "content": 'See results',
      "animation": "",
      "to": {
        name: 'Result'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleClick($event)
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "handleMsg"
  }, [_vm._v("Drag this\n      "), _c('span', {
    staticClass: "handleMsgBold"
  }, [_vm._v("handle")]), _vm._v(" to explore the\n      "), _c('br'), _vm._v("different upgrade stages at Tuxpan\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41c3ed26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/compare.vue
// module id = 224
// module chunks = 1